import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  role: string;
  element: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ role, element }) => {
  const storedRole = localStorage.getItem('role');
  const token = localStorage.getItem('token');

  // If no token or role is present, redirect to login
  if (!token || !storedRole) {
    return <Navigate to="/login" />;
  }

  // If the stored role doesn't match the required role, redirect to the appropriate dashboard
  if (storedRole !== role) {
    return <Navigate to={storedRole === 'superadmin' ? '/superadmin' : '/client'} />;
  }

  // If authenticated and role matches, render the provided element
  return element;
};

export default ProtectedRoute;